import script from "./CommunityIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityIcons.vue?vue&type=script&setup=true&lang=js"

import "./CommunityIcons.vue?vue&type=style&index=0&id=540bcc90&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540bcc90"]])

export default __exports__